<template>
    <div>
        <models-base-form
            :creating="creating"
            :newObject="newObject"
            :editObject="infoadicional"
            :service="service"
            @created="onCreated($event)"
            @updated="onUpdated($event)"
        >
            <template v-slot:form="{ object }">
                <v-text-field v-model="object.infoAdicional" label="Nombre"></v-text-field>
                <v-checkbox v-model="object.isLink" label="Es Link"></v-checkbox>
                <v-text-field v-model="object.valor" label="Valor"></v-text-field>
            </template>
        </models-base-form>
    </div>
</template>

<script>
import { InfoAdicionalesService } from "../../../services/carreras-api.service"
export default {
    data() {
        return {
            service: InfoAdicionalesService,
            newObject: {
                infoAdicional: null,
                isLink: null,
                valor: null,
                carreraSedeId: this.carreraSedeId
            }
        }
    },
    props: ["creating", "infoadicional", "carreraSedeId"],
    methods: {
        onCreated(infoadicional) {
            this.$emit("created", infoadicional)
        },
        onUpdated(infoadicional) {
            this.$emit("updated", infoadicional)
        }
    }
}
</script>
